module.exports = __webpack_public_path__ + "img/icon45.3cc81ef7.png";